import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/province'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(province, uuid) {
    return http.post(`${resource}/${uuid}?_method=PATCH`, province, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  add(province) {
    return http.post(`${resource}`, province, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
